import type { DefaultOptionType } from 'antd/es/select';

export const filterLabelOption = (input: string, option?: DefaultOptionType) =>
  (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase());
